import ajax from "./ajax";


export const busList = params => ajax(`/home/busList`, params,'POST');
export const rotaList = params => ajax(`/home/rotaList`, params,'POST');
export const cooperList = params => ajax(`/home/cooperList`, params,'POST');
export const articleList = params => ajax(`/home/articleList`, params,'POST');
export const proList = params => ajax(`/home/proList`, params,'POST');
























